import { Box, ChakraAsyncSelect, FormControl } from '@elkaso-app/web-design';
import http from 'apis/config/vendor-http-service';
import _debounce from 'lodash/debounce';
import { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';

type TOption = {
  value: string;
  label: string;
};

type FormInputs = {
  items: TOption | undefined;
};

const defaultValues: FormInputs = {
  items: undefined,
};

export interface ISelectAsyncItemsCell {
  row: Record<string, any>;
  id: number;
  defaultValue: { id: string; name: string };
}

export const SelectAsyncItemsCell = ({ row, id, defaultValue }: ISelectAsyncItemsCell) => {
  const [hasDefaultValue, setHasDefaultValue] = useState(false);

  const { control, setValue } = useForm<FormInputs>({
    mode: 'onBlur',
    reValidateMode: 'onChange',
    defaultValues,
  });

  useEffect(() => {
    if (!hasDefaultValue && defaultValue?.id && defaultValue?.name) {
      setValue('items', { label: defaultValue.name, value: defaultValue.id });
      setHasDefaultValue(true);
    }
  }, [hasDefaultValue, defaultValue]);

  const handleRowStateUpdate = (selected: any) => {
    // When cleared
    if (!selected) {
      row.setState({});
    }

    // When selected
    if (selected) {
      row.setState({ itemId: id, vendorItemId: selected.value });
    }
  };

  const debouncedLoadOptions = _debounce((inputValue, callback) => {
    http
      .get('/items', {
        params: { name: inputValue, page: 1, limit: 50 },
      })
      .then(({ data }) => {
        const values: TOption[] = data?.data?.map((item: any) => {
          return { value: item?.id, label: item?.name };
        });

        callback(values);
      });
  }, 500);

  return (
    <Box>
      <Controller
        control={control}
        name='items'
        render={({ field: { onChange, name, onBlur, value } }) => (
          <FormControl>
            <ChakraAsyncSelect
              id='items'
              onChange={(newValue) => {
                handleRowStateUpdate(newValue);
                onChange(newValue);
              }}
              name={name}
              onBlur={onBlur}
              value={value}
              isClearable
              placeholder='Type product name'
              loadOptions={debouncedLoadOptions}
            />
          </FormControl>
        )}
      />
    </Box>
  );
};
